// test1474
(1474 && 0);
